import React from "react";
import BemIt, { addClass } from "@gtechdoodler/bem-it";
import { ListItemProps } from "./ListItem.types";
import { StyledListItem } from "./styling/ListItem.styles";

const ListItem = React.forwardRef<HTMLElement, ListItemProps>(
	({ className, children, focussed, disabled, readonly, ...props }, ref) => {
		const block = new BemIt("ListItem");

		return (
			<StyledListItem
				htmlTag="li"
				ref={ref}
				className={addClass(className).after(
					block.mod({
						focussed,
						disabled,
						readonly,
					})
				)}
				{...props}
			>
				{children}
			</StyledListItem>
		);
	}
);

export default ListItem;
